<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">三年覆盖逾百万适龄女性！腾讯优图以AI助力宫颈癌高效防控</div>
      <div class="news-date">2023年12月5日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          宫颈癌是目前唯一病因明确、早期可预防和治疗、潜在消除的癌症。早期诊断与治疗对于宫颈癌的预防和治愈至关重要。然而，据2022年国家癌症中心报告显示，2022年我国新发宫颈癌病例约有11.93万例，死亡人数约为3.72万人。
        </p>
        <p>
          尽管相关部门已经投入了巨大精力，但受限于经济发展的不平衡性，不少欠发达地区的居民教育程度较低，对宫颈癌的早期临床症状不够了解，再加上基层医务人员专业知识水平的不足，早期筛查宫颈癌是临床面临的一项重要挑战。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news48.png"/>
          </div>
        </div>
        <p>
          针对此，在国家卫生健康委妇幼健康司的指导下，腾讯SSV健康普惠实验室联合中国疾控中心妇幼中心、中国出生缺陷干预救助基金会发布“低资源地区女性两癌综合防控示范项目”，在四川、云南开展先行示范，并联合北京协和医学院专家团队在多省市自治区探索低卫生资源地区“两癌”（宫颈癌、乳腺癌）综合防控的创新模式。
        </p>
        <p>
          在该项目中，
          <span class="mark-text highlight">腾讯优图实验室天衍研究中心提供了领先的多元AI能力，包括高效精准的疾病分类、病灶分割、病灶检测、质控体系建立等。</span>
          推动电子阴道镜影像辅助诊断等创新技术在低资源地区的应用落地，推进“两癌”综合防控，通过在中西部七省30余个地区开展试点，助力加速消除宫颈癌的目标。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news48/news48_1.png"/>
          </div>
        </div>
        <p>
          阴道镜检查技术对医生的主观经验十分依赖，尤其在低卫生资源基层地区，宫颈病灶复杂程度高、阴道镜医生稀缺、医疗水平层次不齐，导致漏诊、误诊的情况时有发生，严重影响宫颈癌的筛查和预防效果。漏误诊会让“宫颈癌的筛查落在基层”这个目标难以实现。
        </p>
        <p>
          基于此，腾讯优图实验室天衍研究中心全新开发了深度学习框架。该AI算法不仅能辅助医生阅片和进行阴道镜下癌前病变的辅助诊断，在几十秒内智能识别异常患者，更致力于从技术上解决由于缺乏专业的阴道镜医生和只能依赖操作医师的主观经验而造成的不必要活检与活检位置判定不准确的问题。
          <span class="mark-text highlight">通过AI辅助医生进行更准确的诊断并对宫颈病变区域进行精准活检取样，辅助基层医生打通宫颈癌筛查的“最后一公里”。</span>
        </p>
        <p>
          腾讯优图实验室天衍研究中心高级研究员黄雅雯介绍，“我们采用了多尺度多色域的深度学习检测模型，通过扩张的方式提升通道数，获取更多特征进行学习，以提高模型在多中心数据上的取样准确率。同时，全局注意机制特征库为阴道镜医师提供了多尺度视角进行病变区域分割的支持，并已在大规模宫颈病变分割数据集上展现出出色的效果。”
        </p>
        <p>
          据了解，这项技术不仅仅局限于图像识别，更是综合了阴道镜医生的多个维度的诊断信息，包括子宫颈细胞学检查（TCT）和HPV状态等非图像信息，准确模拟了阴道镜专家的诊断能力。
        </p>
        <p>
          据悉，为期三年的项目将覆盖逾百万适龄女性（9-14岁女孩、35-64岁女性），提供全方位的“两癌”预防、筛查、诊治服务，着力提升基层医疗服务水平和医生能力。
        </p>
        <p>
          腾讯优图实验室天衍研究中心负责人、腾讯杰出科学家郑冶枫表示，科技向善是我们的理念、以人为本是我们的初心。宫颈癌作为一种可预防、可诊治的癌症，虽然政府已经制定了明确的行动计划，但在低资源地区的落地依然遇到各类问题。
          <span class="mark-text highlight">
            我们的核心AI能力，尤其是在电子阴道镜辅助诊断系统方面的突破，能够为医生提供强大的支持和指导，显著提升诊断效率和准确性。未来，我们也将不断迭代技术能力，为基层医疗服务提供更有力的支持、为妇女疾病的预防和治疗做出更积极的贡献。
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News48',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News48.vue